import { useContext, useState } from 'react';
import { IconButton, Tooltip, useTheme } from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import axios from 'axios';
import { ThemeContext, UserContext } from '../Context';

//Composant qui affiche le bouton permettant de basculer entre le mode jour et le mode nuit.

function ThemeSwitcher() {
  const { theme: themeMode, toggleTheme } = useContext(ThemeContext);
  const { user } = useContext(UserContext);
  const theme = useTheme();
  const [loading, setLoading] = useState(false);

  const handleThemeToggle = async () => {
    if (!user || loading) return;

    setLoading(true);
    const newTheme = themeMode === 'light' ? 'dark' : 'light';

    try {
      const token = sessionStorage.getItem('authToken');
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      // Sauvegarder la nouvelle préférence en base de données
      await axios.put(
        `/api/user/${user}/settings`,
        { themePreference: newTheme },
        config
      );

      // Changer le thème localement après la sauvegarde réussie
      toggleTheme();
    } catch (err) {
      console.error('Erreur lors de la sauvegarde de la préférence de thème:', err);
      // En cas d'erreur, on change quand même le thème temporairement
      toggleTheme();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tooltip 
      title={themeMode === 'dark' ? 'Passer en mode clair' : 'Passer en mode sombre'}
      arrow
      placement="bottom"
    >
      <IconButton
        onClick={handleThemeToggle}
        disabled={loading}
        sx={{
          p: { xs: 0.75, sm: 1.25 },
          transition: 'all 0.3s ease',
          borderRadius: '100%',
          color: theme.palette.primary.contrastText,
          opacity: loading ? 0.6 : 1,
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            transform: loading ? 'none' : 'scale(1.1)',
          },
          '&:active': {
            transform: loading ? 'none' : 'scale(0.95)',
          },
          '&:disabled': {
            color: theme.palette.primary.contrastText,
            opacity: 0.6,
          },
          animation: themeMode === 'dark' ? 'none' : 'spin 0.5s ease-out',
          '@keyframes spin': {
            '0%': {
              transform: 'rotate(-180deg)',
            },
            '100%': {
              transform: 'rotate(0deg)',
            },
          },
        }}
      >
        {themeMode === 'dark' ? (
          <LightModeIcon 
            sx={{ 
              fontSize: '1.35rem',
              color: '#ffffff',
              filter: 'drop-shadow(0 0 2px rgba(255, 255, 255, 0.5))',
              animation: loading ? 'pulse 1.5s ease-in-out infinite' : 'none',
              '@keyframes pulse': {
                '0%': { opacity: 1 },
                '50%': { opacity: 0.5 },
                '100%': { opacity: 1 },
              },
            }} 
          />
        ) : (
          <DarkModeIcon 
            sx={{ 
              fontSize: '1.35rem',
              color: 'inherit',
              animation: loading ? 'pulse 1.5s ease-in-out infinite' : 'none',
              '@keyframes pulse': {
                '0%': { opacity: 1 },
                '50%': { opacity: 0.5 },
                '100%': { opacity: 1 },
              },
            }} 
          />
        )}
      </IconButton>
    </Tooltip>
  );
}

export default ThemeSwitcher;